import React, { FC, useCallback, useState, useEffect, memo } from 'react'
import { useController } from 'react-hook-form'
import { InputGroup, Select } from '@wmgtech/legato'
import { useAdvertisers } from 'modules/Advertisers/services'
import { IFieldError, validationAdapter } from 'components/Fields'
import { IAdvertiser } from 'modules/Admin'

export const FormAdvertiserSelect: FC = memo(() => {
  const NAME = 'advertiser'
  const { field: { onChange, ref, ...rest }, formState: { errors } } = useController({ name: NAME })
  const [options, setOptions] = useState<IAdvertiser[]>([]);
  const { advertisers } = useAdvertisers()

  const handleChange = useCallback((adv: IAdvertiser) => {
    if (adv) {
      onChange(adv.id)
    }
  }, [onChange])

  const onSearch = useCallback((list: IAdvertiser[], term: string): IAdvertiser[] =>
    term && advertisers ?
      advertisers.filter((opt: IAdvertiser) => opt.name.toLowerCase().includes(term.toLowerCase())) :
      advertisers ?? [], [advertisers])

  const validation = useCallback((error?: IFieldError) => ({
    required: true,
    ...validationAdapter(error),
  }),[])

  useEffect(() => {
    advertisers && setOptions(advertisers);
  }, [advertisers])

  return (
    <InputGroup label="Advertiser" validation={validation(errors[NAME] as IFieldError)}>
      <Select<IAdvertiser>
        onSelect={handleChange}
        placeholder="Select Advertiser"
        list={options}
        getKey={(el) => el.id}
        getTitle={(el) => el.name}
        isFilterable
        onFilter={onSearch}
        searchInputPlaceholder="Type Advertiser"
        {...rest}
      />
    </InputGroup>
  )
})
